export { SimpleDataPoint, type SimpleDataPointProps } from './SimpleDataPoint';
